import { useState } from 'react';
import { useStores } from '@/hooks/use-stores';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { Button, Col, Image, Row } from 'antd';
import QuestionCircleOutlined from '@/comp/common/icons/QuestionCircleOutlined';
import { useTranslation } from 'react-i18next';
import { ImageUploadButtons } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/common';
import { useImageCompression } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/hooks/useImageCompression';
import { ImageTagsDrawer } from './components';
import { StyledStep } from './ImagePreviewMobile.styles';

export const ImagePreviewMobile = observer(() => {
  const { t } = useTranslation();
  const { imageUploadStore } = useStores();
  const { images, maxFiles } = imageUploadStore;
  const [isImageTagsDrawerOpen, setIsImageTagsDrawerOpen] = useState(false);
  const params = useImageCompression({});

  const openImageTagsDrawer = () => setIsImageTagsDrawerOpen(true);
  const closeCompressorDrawer = () => setIsImageTagsDrawerOpen(false);

  return (
    <StyledStep>
      <Button
        type="text"
        className="open-image-tags-drawer-btn"
        icon={<QuestionCircleOutlined />}
        onClick={openImageTagsDrawer}
      >
        {t('uploadImageMobilePreviewHelperText')}
      </Button>
      <div className={classNames('images-container', { 'single-image': images.length === 1 })}>
        {images.length > 1 ? (
          <Row className="image-list" gutter={[16, 32]}>
            {images.map(({ url, id, file }) => (
              <Col key={id} className="image-container" span={12}>
                <Image className="image" src={url} preview={false} alt={file.name} />
              </Col>
            ))}
          </Row>
        ) : (
          <Image src={images[0].url} alt={images[0].file.name} preview={false} />
        )}
      </div>
      <div className="image-preview-footer">
        <Button block size="large" type="primary" onClick={imageUploadStore.goToNextStep} disabled={params.isLoading}>
          {t('uploadImageMobilePreviewContinueButtonText')}
        </Button>
        {images.length < maxFiles && (
          <ImageUploadButtons buttonType="text" buttonText="uploadImageUnifiedButtonAddAnotherText" {...params} />
        )}
      </div>
      <ImageTagsDrawer open={isImageTagsDrawerOpen} onClose={closeCompressorDrawer} />
    </StyledStep>
  );
});
